module.exports = __webpack_public_path__ + "static/img/t1.c312e5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/t1.png
// module id = DaXA
// module chunks = 1